var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { attrs: { id: "app" } },
    [
      _vm.showButton()
        ? _c(
            "div",
            { staticClass: "button-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: { id: "show-bp", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showChatbot()
                    }
                  }
                },
                [_c("i", { staticClass: "fal fa-comments-alt icon-size" })]
              )
            ],
            1
          )
        : _vm._e(),
      _c("el-header", { staticClass: "header-menu" }, [_c("app-header")], 1),
      _c(
        "el-main",
        [_c("router-view", { staticClass: "home-content" }), _c("app-footer")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ddcfcc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ddcfcc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/MainPage.vue
// module id = null
// module chunks = 